import { defineComponent as _defineComponent } from 'vue'
import { EventBus } from '@/utils/eventBus';
import tripModificationService from '@/services/tripModification';
import tripModification from '@/store/modules/tripModification';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditTripButton',
  props: {
    managedId: null
  },
  setup(__props: any) {

const props = __props as {
  managedId: string
};



const openTripModificationStartDialog = async (): Promise<void> => {
  try {
    const res = await tripModificationService.hasDraft(props.managedId)
    tripModification.setIsDraftInProgress(res.data)
  } catch (error) {
    console.error(error)
  }
  EventBus.$emit('open-trip-modification-dialog')
}

return { __sfc: true,props, openTripModificationStartDialog }
}

})